
const Header = () => {
  return (
      <h1>Nathan Murray</h1>
  );
};

export default Header;
